import Marquee from "react-fast-marquee";

export function MarqueeLine1() {
  return (
    <Marquee
      speed={100}
      gradient={true}
      gradientColor="#1A1E23"
      gradientWidth={400}
      autoFill={true}
      style={{ 
        background: "#1A1E23",
        padding: "5px 0",
        zIndex: "3"
      }}
    >
      🚀 Это моя бегущая строка! | 🎉 Можно вставить картинки! | 🔥 React рулит!
    </Marquee>
  );
}

export function MarqueeLine2() {
  return (
    <Marquee
      speed={100}
      gradient={true}
      gradientColor="#1A1E23"
      gradientWidth={400}
      autoFill={true}
      direction="right"
      style={{ 
        background: "#1A1E23",
        padding: "5px 0",
        zIndex: "3"
      }}
    >
      🚀 Это моя бегущая строка! | 🎉 Можно вставить картинки! | 🔥 React рулит!
    </Marquee>
  );
}
